import {IReferral} from './IReferral';
import {ICipQuestions} from './ICipQuestions';
import {LivenessPassiveTestResult} from './liveness-passive-test-result';

export enum ApplicationStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CANCELLED = 'CANCELLED',
  ERROR = 'ERROR',
  LOCK = 'LOCK',
  BLACK_LISTED = 'BLACK_LISTED',
  PENDING_BLACK_LIST = 'PENDING_BLACK_LIST',
  EMAIL_VALIDATION = 'EMAIL_VALIDATION',
  ACCOUNT_CREATION_ERROR = 'ACCOUNT_CREATION_ERROR',
  BLACK_LIST_QUESTIONS = 'BLACK_LIST_QUESTIONS',
  BLACK_LIST_DOCUMENTS = 'BLACK_LIST_DOCUMENTS',
  DENIED = 'DENIED',
  DATA_UPDATE = 'DATA_UPDATE'
}

export interface ApplicationBody {
  addressInteriorNumber?: string;
  latitude: number | null;
  longitude: number | null;
  deviceIdentifier?: string;
  idCity?: number;
  idState?: string;
  publicityConsent?: boolean;
  securityQuestionAnswer?: string;
  securityQuestionKey?: string;
  securityAnswer?: string;
  documents?: string[];
  idType?: string;
  idNumber?: string;
  emissionDate?: string;
  expirationDate?: string;
  rejectedAppToken?: string;
  applicationId?: number;
  addressExteriorNumber?: string;
  dateOfBirth?: string;
  cellphone?: string;
  phoneCountryCode?: string;
  city?: string;
  country?: string;
  email?: string;
  ipAddress?: string;
  firstName: string | null;
  additionalNames: string | null;
  lastName: string | null;
  secondLastName: string | null;
  gender: string | null;
  ocrFirstName?: string | null;
  ocrAdditionalNames?: string | null;
  ocrLastName?: string | null;
  ocrSecondLastName?: string | null;
  ocrDateOfBirth?: string | null;
  ocrGender?: string | null;
  ocrFieldsConfirm?: boolean | null;
  ocrBirthplaceName?: string | null;
  ocrBirthplace: string | null;
  matchingPassword?: string;
  password?: string;
  platform: string;
  postalCode?: number;
  state?: string;
  street?: string;
  privacyAdvice?: boolean;
  idConsent?: boolean;
  termNCond?: boolean;
  shortFormAgreement?: boolean;
  cardHolderAgreement?: boolean;
  locale?: string;
  fiscalIdentifier?: string;
  socialSecurityNumber: string | null;
  driverLicenseNumber?: string;
  identificationType?: string;
  identification2Type?: string;
  identificationNumber?: string;
  identificationCountry?: string;
  identification2Country?: string;
  identificationEmissionDate?: number;
  identificationExpirationDate?: number;
  referrals: IReferral[];
  cipQuestions: ICipQuestions[];
  status?: ApplicationStatus;
  altairParentAgentId?: number;
  citizenshipId?: number;
  citizenshipCountry?: string;
  kycStatus?: string;
  applicationRejected?: boolean;
  hasDriverLicenseNumber?: boolean;
  hasSocialSecurityNumber?: boolean;
  birthplaceName: string | null;
  birthplace: string | null;
  pronoun: string | null;
  livenessPassiveTestResult: LivenessPassiveTestResult | null;
  externalReferenceCode: string | null;
  agentMode: string | null;
  suspicious: boolean | null;
  applicationHash: string | null;
  phoneOtp?: string;
}
